import { isIos } from '@constants/os';
import { VersionResponse } from '@models/version';
import axios from 'axios';
import { useEffect } from 'react';
import { toast } from 'sonner';

function useDeepLinkRedirection(projectId: string) {
    function checkAppInstalled(appScheme?: string): Promise<boolean> {
        if (!appScheme) {
            return Promise.resolve(false);
        }
        return new Promise((resolve) => {
            let appOpened = false;
            const handleVisibilityChange = () => {
                if (document.hidden) {
                    appOpened = true;
                }
            };
            document.addEventListener('visibilitychange', handleVisibilityChange);
            window.location.replace(`${appScheme}deepLink${window.location.search}`);
            setTimeout(() => {
                document.removeEventListener(
                    'visibilitychange',
                    handleVisibilityChange,
                );
                resolve(appOpened);
            }, 1500);
        });
    }

    const handleDeepLink = async () => {
        try {
            const { storeUrl, appScheme } = await getAppVersion(projectId);
            const appInstalled = await checkAppInstalled(appScheme);
            if (!appInstalled) {
                window.location.replace(storeUrl);
            }
            window.location.replace(`/link?projectId=${projectId}`);
        } catch (e) {
            console.error(e);
            toast.error('정보를 불러오는데 실패했습니다.');
        }
    };

    useEffect(() => {
        handleDeepLink();
    }, [projectId]);
}

function getAppVersion(projectId: string): Promise<VersionResponse> {
    return new Promise((resolve, reject) => {
        axios.get(`${import.meta.env.VITE_API_URL}/v0/app-versions/check`, {
            params: {
                osType: isIos ? 'IOS' : 'AOS',
                appType: 'ORDER',
                version: 1,
            },
            headers: { 'Waldlust-Project-ID': projectId },
        })
            .then((res) => {
                resolve(res.data);
            }).catch((e) => {
                reject(e);
            });
    });
}

export default useDeepLinkRedirection;
